<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';
import swal from 'sweetalert';

export default {
    name: 'CcManagerRegistrationForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            alertShown: false,
        };
    },

    computed: {
        isSelfPoliticallyVulnerable() {
            return this.model.$.vulnerable.find(item => item.type === 1);
        },
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    methods: {
        showAlert(notice) {
            if (this.alertShown) {
                return;
            }

            if (notice) {
                this.alertShown = true;
                swal({
                    title: 'Dėmesio!',
                    text: notice,
                    icon: 'info',
                    button: {
                        text: 'Supratau',
                        className: 'btn btn-primary',
                    },
                });
            }
        },

        addVulnerable() {
            this.model.$.vulnerable.push({
                type: null,
                vulnerabilities: [],
            });
        },

        removeVulnerable(entry) {
            this.model.$.vulnerable = this.model.$.vulnerable.filter((vulnerable) => vulnerable !== entry);
        },

        vulnerabilityChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            if (!relation.vulnerabilities.length) {
                return;
            }

            relation.vulnerabilities = relation.vulnerabilities.slice(relation.vulnerabilities.length - 1, relation.vulnerabilities.length);
        },

        typeChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            relation.vulnerabilities = [];
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
